import styled from 'styled-components';

import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import { GENERAL_CONTACT_INFO } from 'src/consts';
import type { ThemeColorType } from 'src/styles/theme';

import type { PropsFromRedux } from './container';

const StyledLink = styled.a<{ color?: ThemeColorType }>`
  color: ${props => (props.color ? props.theme.colors[props.color] : props.theme.colors.capsuleGreen60)} !important;
`;

interface DefaultPhoneNumberProps extends PropsFromRedux {
  className?: string;
  color?: ThemeColorType;
}

export const DefaultPhoneRenderer = ({ className, color, dispatchSegmentTrack }: DefaultPhoneNumberProps) => {
  const handleClick = () => {
    dispatchSegmentTrack(UNIFIED.contactUsCallOrText, { openedFrom: window?.location?.pathname });
  };
  return (
    <StyledLink
      className={className}
      color={color}
      href={`tel:${GENERAL_CONTACT_INFO.CAPSULE_CALL_NUMBER}`}
      onClick={handleClick}
    >
      {GENERAL_CONTACT_INFO.CAPSULE_CALL_NUMBER_FORMATTED}
    </StyledLink>
  );
};
